var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-button-group",
    _vm._l(_vm.options, function(year) {
      return _c(
        "b-button",
        {
          key: year,
          attrs: { variant: _vm.buttonVariant(year), size: "sm" },
          on: {
            click: function($event) {
              return _vm.select(year)
            }
          }
        },
        [_vm._v("\n        " + _vm._s(year) + "\n    ")]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }